import React, { useEffect, useState } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import UserNavbar from '../Navbar/UserNavbar'
import { AiFillFileExcel, AiFillFilePdf, AiOutlineFileText } from 'react-icons/ai'
import axios from 'axios'
import { toast } from 'react-toastify';
import { Button, DatePicker, Input, Select, Table ,Checkbox, Tooltip, Spin} from 'antd';
import dayjs from 'dayjs';
import { Option } from 'antd/es/mentions';
import { useNavigate } from 'react-router-dom'
import { ExpenseEntrySummary, PaymentRecieveSummery , ReceiptReport } from '../Api/All_Api'
import { getReportDataApi } from '../Api/CommonApi'
import TitleNavbar from '../Navbar/TitleNavbar'


const ReceiptSummary = () => {
     const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];
    
      const role = sessionStorage.getItem('role');

      const branchId = sessionStorage.getItem('branchId');
        const sessionYear = sessionStorage.getItem('sessionYear');
        const year = sessionYear

      const navigate = useNavigate();
          useEffect(() => {
            if (!sessionYear) {
              sessionStorage.clear();
              navigate('/')
            }
          },[])
    
      const [errors, setErrors] = useState({
        toDate: "",
        fromDate: "",
        Type:"",
      });
      const [toDate, setToDate] = useState("");
      const [PaymentRecieve, setPaymentRecieve] = useState([]);
      const [fromDate, setFromDate] = useState("");
        const [pageSize, setPageSize] = useState(10);
          const [filteredData, setFilteredData] = useState([]);
          const [currentPage, setCurrentPage] = useState(1);
          const [totalEntries, setTotalEntries] = useState(0);
          const[viewButton,setViewButton]=useState(false);
          const[Type,setType]=useState("1");
      
          const [loading, setLoading] = useState(false);


   //======Search data from table===============
   const handleSearch = (value) => {
    const filtered = PaymentRecieve.filter((item) =>
      Object.values(item).some((val) =>
        val?.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
    setTotalEntries(filtered.length); // Update total entries count after filtering
    setCurrentPage(1);
  };
  // //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };


  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Sale Bill Number",
      dataIndex: "sale_bill_no",
      key: "sale_bill_no",
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
        title: " Recieved Amount",
        dataIndex: "receieved_amount",
        key: "receieved_amount",
      },
      {
        title: "Payment Recieved Date",
        dataIndex: "payment_receieved_date",
        key: "payment_receieved_date",
      },
    
 
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };
    

     const handleSubmit = async () => {
      
      if (!fromDate || !toDate || !Type) {
        setErrors({
          ...errors,
          fromDate: fromDate ? "" : "From Date is required.",
          toDate: toDate ? "" : "To Date is required.",
          Type: Type?"": "Type is required",
        });
        return;
      }
      setLoading(true);
        const formattedFromDate = fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : '';
         const formattedToDate = toDate ? dayjs(toDate).format('YYYY-MM-DD') : '';

try{
    const response = await axios.get(`${ReceiptReport}?fromDate=${formattedFromDate}&toDate=${formattedToDate}&reportId=${Type}&branchId=${branchId}&accYear=${year}`);
    console.log("Response data:", response);
    setLoading(false);
    let reportUrl = response.data;
    console.log("Response data:", response.data);
    if(reportUrl === "REPORT FILE NOT FOUND"){
      toast.warn('Report File Not Found...!!', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });} else {
        const reportLink =  getReportDataApi + `output/${reportUrl}`;
      window.open(reportLink, "_blank");
    }
  } catch (error) {
    setLoading(false);
    console.error("Error during API call:", error);
    toast.error("Error occurred while submitting data");
  }


  setErrors({ ...errors,
    fromDate:  "" ,
    toDate: "" ,
   Type:"",});


      };
    // ==============Get table data================
  
    let isError = false;
  
    const fetchPaymentRecieve = async () => {

      if (!fromDate || !toDate || !Type) {
        setErrors({
          ...errors,
          fromDate: fromDate ? "" : "From Date is required.",
          toDate: toDate ? "" : "To Date is required.",
          Type: Type?"": "Type is required",
        });
        return;
      }
      setLoading(true);
    const formattedDate = fromDate
            ? dayjs(fromDate).format("YYYY-MM-DD")
            : "";
              const formattedDate1 = toDate
                ? dayjs(toDate).format("YYYY-MM-DD")
                : "";
    
      try {
        const response = await axios.get(`${PaymentRecieveSummery}?fromDate=${formattedDate}&toDate=${formattedDate1}&branchId=${branchId}&accYear=${year}`);
      if (response.data && Array.isArray(response.data)) {
                     if (response.data.length > 0) {
                       setPaymentRecieve(response.data);
                       setFilteredData(response.data); 
                       setTotalEntries(response.data.length);
                       setViewButton(true);
                     } else {
                       setPaymentRecieve([]); // No data available, set empty
                       setFilteredData([]); // Set empty filtered data
                       console.log("No data available for the given date range .");
                       toast.success("No data available for the given date range .");
                     }
                   } else {
                     // Handle invalid data structure
                     console.error('Invalid response data:', response.data);
                     toast.error('Failed to fetch : Invalid data structure');
                   }
                 }catch (error) {
        if (!isError) {
          // Check if the error has already been triggered
          console.error("Error fetching Payment Recieved:", error);
          toast.error("Failed to fetch Payment Recieved data");
          isError = true; // Set the flag to prevent double toast
        }
      }
      finally{
        setLoading(false);
      }
      setErrors({
        ...errors,
        fromDate:  "",
        toDate:  "" ,
        Type:"",
      });
   
    };
  
    const handleView = () => {
      setType(0); // Type for HTML/Table view
      fetchPaymentRecieve();
     
    };
    
    const handleDownloadPDF = () => {
      setType(1); // Type for PDF download
      handleSubmit();
   
    };
    
    const handleDownloadExcel = () => {

      setType(2); // Type for Excel download
      handleSubmit();
      
    };
           //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================

      
  return (
    <> 
     <AdminNavbar /> 
       <div className="p-0 m-0">
    
            <div
              className="row m-0"
              style={navbg}
            >
              <div
                className="col-12 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                <span className="px-md-5"  style={{ flexGrow: 1 }}>
                  {" "}
                  <AiOutlineFileText /> &nbsp; Receipt Summary
                </span>
                <span >
            <TitleNavbar/>
            </span>
              </div> </div>
              <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
              <div className="row px-md-5 mt-3  m-0">
                {/* <div className="col-12 pt-2 ">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels"  style={{fontSize:16}}>Type: </label>
                    </div>
                    <div className="col-9 col-lg-6">
                    <Select
                       value={Type || undefined}
                       onChange={(value) => setType(value)}
                           showSearch
                      className="w-100"
                     placeholder="Select Type"
                       optionFilterProp="children">
                                  <Select.Option value="1">
                                  Pdf
                                  </Select.Option>
                                  <Select.Option value="2">
                                   Excel
                                  </Select.Option>
                                 
                              </Select>
                             
                          {errors.Type && (
                            <div className="errorField">{errors.Type}</div>
                          )}
                    </div>
                  </div>
                </div> */}
                <div className="col-12 pt-2 ">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels"  style={{fontSize:16}}>From Date: </label>
                    </div>
                    <div className="col-9 col-lg-6">
                    <DatePicker
                        defaultValue={null}
                        value={fromDate}
                        onChange={(value) => setFromDate(value)}
                        className="w-100"
                        format={dateFormatList}
                      />
                        {errors.fromDate && (
                          <div className="errorField">{errors.fromDate}</div>
                        )}
                    </div>
                  </div>
                </div>

                <div className="col-12 pt-2 ">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels"  style={{fontSize:16}}>To Date: </label>
                    </div>
                    <div className="col-9 col-lg-6">
                    <DatePicker
                        defaultValue={null}
                        value={toDate}
                        onChange={(value) => setToDate(value)}
                        className="w-100"
                        format={dateFormatList}
                      />
                        {errors.toDate && (
                          <div className="errorField">{errors.toDate}</div>
                        )}
                    </div>
                  </div>
                </div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleView}
                    disabled={loading}
                  >
                    {loading ? <Spin size="small" /> : 'View'} 
                  </Button>
                  
                 
                </div>

                <div
                  className="col-12 p-0 mt-3"
                  style={{ borderBottom: "2px solid #bfb597" }}
                ></div>
              </div>
          </div>
          <div className='col-12 col-md-2 col-lg-4'></div>
        </div>
       
        </div>

   {/* ================ Table ========================= */}
     {viewButton&&(   <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
          <div className='col-12 col-md-2'></div>
            <div  className="col-12 col-md-8 py-3 shadow border"
              style={{ marginBottom: "50px", backgroundColor: "white" }}
            >
              <div
                className="col-12 px-md-5"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                  <Select
                    defaultValue={pageSize}
                    onChange={handlePageSizeChange}
                    style={{ width: 120, textAlign: "center" }}
                  >
                    <Option value={10}>10</Option>
                    <Option value={20}>20</Option>
                    <Option value={30}>30</Option>
                  </Select>
                </div>
  
               <div className="pt-4 pt-md-0" style={{ display: "flex", gap: "10px" }}>
               <Tooltip title="Download PDF" placement="top">
               <div
            style={{
            cursor: 'pointer', 
            fontSize: '24px', 
            color: '#D32F2F',
            marginBottom: 16
          }}
          disabled={loading}
          onClick={handleDownloadPDF}
        >
          <AiFillFilePdf />
        </div>
      </Tooltip>
         <Tooltip title="Download Excel" placement="top">
              <div
             
                style={{
                  cursor: 'pointer', 
                  fontSize: '24px', 
                  color: 'green',
                  marginBottom: 16
                }}
                disabled={loading}
              onClick={handleDownloadExcel}
              >
                <AiFillFileExcel />
              </div>
            </Tooltip>
                  <Input.Search
                    placeholder="Search"
                    onSearch={handleSearch}
                    style={{ width: 200, marginBottom: 16 }}
                  />
                </div>
              </div>
  
              <div style={{ backgroundColor: "white" }}>
                <Table
                  bordered
                  style={{ padding: "0px 20px", overflowX: "auto" }}
                  columns={columns}
                  dataSource={filteredData}
                  pagination={{
                    pageSize: pageSize,
                    total: totalEntries,
                    showTotal: (total, range) =>
                      `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                    current: currentPage,
                    onChange: (page) => setCurrentPage(page),
                  }}
                  showSorterTooltip={false}
                  rowKey={(record) => record.id}
                   components={components}
                />
              </div>
            </div>
            <div className='col-12 col-md-2'></div>
          </div>)}  
        
  


                </>
  )
}

export default ReceiptSummary